import { combineReducers } from 'redux';

import app, { defaultState as appDefaultState } from './app/reducer';
import entities, { defaultState as entitiesDefaultState } from './entities/reducer';
import type { State } from './types';
import ui, { defaultState as uiDefaultState } from './ui/reducer';

const reducer = combineReducers({
	app,
	ui,
	entities,
});

export const defaultState = {
	app: appDefaultState,
	ui: uiDefaultState,
	entities: entitiesDefaultState,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (sweetStateUpdater: (state: State) => void) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(state: any = defaultState, action: any) => {
		const outputState = reducer(state, action);

		sweetStateUpdater(outputState);

		return outputState;
	};
